import React, { FC } from 'react'
import { Modal, ModalProps } from '../../Modal'
import { TemplateSheetAnalysisModalContent } from './content'
import { useAppDispatch } from '../../../app/hooks'
import { handleTemplateSheetAnalysisInfoModal} from '../../../features/modals/modalsSlice'



export const TemplateSheetAnalysisInfoModal: FC<ModalProps & {data: any}> = ({ opened, level, data }) => {
    const dispatch = useAppDispatch()

    const handleModal = (data: any) => {
        dispatch(handleTemplateSheetAnalysisInfoModal(data))
    }
    return (
        <Modal opened={opened}>
            <TemplateSheetAnalysisModalContent level={level} handleModal={() => handleModal(data)} data={data}/>
        </Modal>
    )
}
